export function prettifyJson(json: string) {
    return JSON.stringify(JSON.parse(json), undefined, 4);
}